import { render, staticRenderFns } from "./FormAddress.vue?vue&type=template&id=049316c8&scoped=true"
import script from "./FormAddress.vue?vue&type=script&lang=js"
export * from "./FormAddress.vue?vue&type=script&lang=js"
import style0 from "./FormAddress.vue?vue&type=style&index=0&id=049316c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049316c8",
  null
  
)

export default component.exports